/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class CrossSectionApi extends runtime.BaseAPI {
    /**
     * Create Cross Section
     */
    async v2CreateCrossSectionRaw(requestParameters, initOverrides) {
        if (requestParameters['crossSectionCreate'] == null) {
            throw new runtime.RequiredError('crossSectionCreate', 'Required parameter "crossSectionCreate" was null or undefined when calling v2CreateCrossSection().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/cross_section/`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['crossSectionCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Cross Section
     */
    async v2CreateCrossSection(requestParameters, initOverrides) {
        const response = await this.v2CreateCrossSectionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete Cross Section
     */
    async v2DeleteCrossSectionRaw(requestParameters, initOverrides) {
        if (requestParameters['crossSectionId'] == null) {
            throw new runtime.RequiredError('crossSectionId', 'Required parameter "crossSectionId" was null or undefined when calling v2DeleteCrossSection().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/cross_section/{cross_section_id}`;
        urlPath = urlPath.replace(`{${"cross_section_id"}}`, encodeURIComponent(String(requestParameters['crossSectionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete Cross Section
     */
    async v2DeleteCrossSection(requestParameters, initOverrides) {
        await this.v2DeleteCrossSectionRaw(requestParameters, initOverrides);
    }
    /**
     * Read Cross Section
     */
    async v2ReadCrossSectionRaw(requestParameters, initOverrides) {
        if (requestParameters['crossSectionId'] == null) {
            throw new runtime.RequiredError('crossSectionId', 'Required parameter "crossSectionId" was null or undefined when calling v2ReadCrossSection().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/cross_section/{cross_section_id}`;
        urlPath = urlPath.replace(`{${"cross_section_id"}}`, encodeURIComponent(String(requestParameters['crossSectionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Read Cross Section
     */
    async v2ReadCrossSection(requestParameters, initOverrides) {
        const response = await this.v2ReadCrossSectionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update Cross Section
     */
    async v2UpdateCrossSectionRaw(requestParameters, initOverrides) {
        if (requestParameters['crossSectionId'] == null) {
            throw new runtime.RequiredError('crossSectionId', 'Required parameter "crossSectionId" was null or undefined when calling v2UpdateCrossSection().');
        }
        if (requestParameters['crossSectionUpdate'] == null) {
            throw new runtime.RequiredError('crossSectionUpdate', 'Required parameter "crossSectionUpdate" was null or undefined when calling v2UpdateCrossSection().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/cross_section/{cross_section_id}`;
        urlPath = urlPath.replace(`{${"cross_section_id"}}`, encodeURIComponent(String(requestParameters['crossSectionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['crossSectionUpdate'],
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update Cross Section
     */
    async v2UpdateCrossSection(requestParameters, initOverrides) {
        await this.v2UpdateCrossSectionRaw(requestParameters, initOverrides);
    }
}
